import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { FaPlusCircle, FaSignOutAlt, FaUser } from "react-icons/fa";

import logourl from "../css/images/logo.jpg";

class NavigationBar extends React.Component {
  render() {
    const { appTitle, navIsOpen, onToggleNav, user } = this.props;
    const fullName =
      user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name}`
        : user.email;
    return (
      <nav className="nav navbar has-shadow flex-1-1">
        <div className="nav-left">
          <h1 className="nav-item title is-2 is-primary">
            {/* appTitle */}
            <div className="logo">
              <Link className="image nav-item" to="/">
                <img alt={appTitle} src={logourl} />
              </Link>
            </div>
          </h1>
        </div>

        <div className="nav-center">
          <a className="nav-item" href="#">
            <span className="icon">
              <i className="fa fa-github" />
            </span>
          </a>
          <a className="nav-item" href="#">
            <span className="icon">
              <i className="fa fa-twitter" />
            </span>
          </a>
        </div>

        <span
          className={`nav-toggle ${navIsOpen ? "is-active" : ""}`}
          onClick={onToggleNav}
        >
          <span />
          <span />
          <span />
        </span>

        <div className={`nav-right nav-menu ${navIsOpen ? "is-active" : ""}`}>
          <Link className="nav-item" to="/map">
            Karte
          </Link>
          <Link className="nav-item" to="/sponsors">
            Förderer
          </Link>
          <Link className="nav-item" to="/about">
            Infos &amp; Hilfe
          </Link>
          <Link className="nav-item" to="/imprint">
            Impressum
          </Link>
          <Link className="nav-item" to="/privacy">
            Datenschutz
          </Link>
          {user.is_admin && (
            <Link className="nav-item" to="/admin">
              Admin
            </Link>
          )}

          {Boolean(user.email) && (
            <span className="nav-item">
              <Link className="button is-success" to="/new">
                <FaPlusCircle className="icon is-small" />
                <span className="is-hidden-tablet-only">
                  {" "}
                  Einrichtung anlegen
                </span>
              </Link>
            </span>
          )}
          {!user.email && (
            <span className="nav-item">
              <Link className="button is-info" to="/login">
                Anmelden
              </Link>
            </span>
          )}
          {!user.email && (
            <span className="nav-item">
              <Link className="button is-info" to="/user">
                Registrieren
              </Link>
            </span>
          )}
          {!!user.email && (
            <span className="nav-item">
              <Link className="button is-info" to="/user">
                <FaUser />
                <span className="is-hidden-tablet-only"> {fullName}</span>
              </Link>
            </span>
          )}
          {!!user.email && (
            <span className="nav-item">
              <Link className="button is-info" to="/logout">
                <FaSignOutAlt />
                <span className="is-hidden-tablet-only"> Abmelden</span>
              </Link>
            </span>
          )}
        </div>
      </nav>
    );
  }
}

NavigationBar.propTypes = {
  appTitle: PropTypes.string,
  navIsOpen: PropTypes.bool,
  onToggleNav: PropTypes.func,
  user: PropTypes.object
};

export default NavigationBar;



/** WEBPACK FOOTER **
 ** ./src/components/NavigationBar.jsx
 **/